import CryptoJS from 'crypto-js'
const key = CryptoJS.enc.Hex.parse('81b120ef00216c33b266763abb02e6d1');
const iv=  CryptoJS.enc.Hex.parse('e6a4cc0507dfe344b042289eeb945dce')
//解密方法
export const Decrypt = (encryptedText)=>{
    let decryptedText = CryptoJS.AES.decrypt(encryptedText,key,{iv,mode:CryptoJS.mode.CBC,padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decryptedText);
}

